import React, {useEffect, useState} from 'react';
import getCommonResponse from '../actions/Common';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import '../../scss/create_new.scss';
import edit from '../../images/common/edit.png';
import trash from '../../images/common/trash.png';
import create from '../../images/projectdetails/add.png';
import AddSubBrand from '../popups/AddSubBrand';
import DeleteItem from '../popups/DeleteItem';

function SubBrands(props) {
    const {page, brandId, setOpen, setError} = props;
    const navigate = useNavigate();
    const [fiveBrandsList, setFiveBrandsList] = useState([]);
    const [brandsList, setBrandsList] = useState([]);
    const [showAllBrands, setShowAllBrands] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const [type, setType] = useState("");
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteBrandId, setDeleteBrandId] = useState(null);
    const initialValues = {
        id: null,
        name: null,
        address: null,
        country: "Select Country",
        zipcode: "",
        state: "",
        city: ""
    };
    const [values, setValues] = useState(initialValues);

    var brands = showAllBrands ? brandsList : fiveBrandsList;

    const handleCloseDeletePopup = () => {
        setShowDeletePopup(false);
    }

    const handleShowDeletePopup = () => {
        setShowDeletePopup(true);
    }

    useEffect(() => {
        const callApi = (accesstoken) => {
            if(accesstoken == '') {
                navigate('/');
            } else {
                const endpoint =  `/api/brand/list?parentBrandId=${brandId}`;
                getCommonResponse.GetDetailsWithToken(endpoint, accesstoken, (data) => {
                    if(data.status == 200) {
                        if(data.data.data.length <= 5) {
                            setFiveBrandsList(data.data.data);
                            setBrandsList(data.data.data);
                        } else {
                            var brands = [];
                            for(var i = 0; i < 5; i++) {
                                brands.push(data.data.data[i])
                            }
                            setFiveBrandsList(brands);
                            setBrandsList(data.data.data);
                        }
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [trigger])

    const showBrands = () => {
        setShowAllBrands(!showAllBrands);
    }

    const handleSubBrand = (type, data=null) => {
        setShowPopup(true);
        setValues(initialValues);
        setType(type);
        if(data != null) {
            setValues({
                ...values,
                id: data.idBrand,
                name: data.name,
                address: data.address,
                country: (data.country != null && data.country != "") ? data.country : "Select Country",
                zipcode: data.zipCode != null ? data.zipCode : '',
                state: (data.state != null && data.state != "") ? data.state : "",
                city: data.city != null ? data.city : ''
            })
        }
    }

    const deleteSubBrand = (e, id) => {
        e.stopPropagation();
        setDeleteBrandId(id);
        handleShowDeletePopup();
    }

    const deleteSubBrandApi = () => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getCommonResponse.DeleteDetails(`/api/brand/delete?brandId=${deleteBrandId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setTrigger(!trigger);
                        handleCloseDeletePopup();
                    } else if(data.status == 401) {
                        navigate("/login")
                    } else {
                        setError(data.data.message);
                        setOpen(true);
                    }
                });
            }
        }
        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    return (
        <div id='sub-brands' className='sub-brands-section'>
            <div className='sub-brands-container'>
                <div className='sub-brands-left'>
                    <div className='sub-brands'>Brands</div>
                    <div className='showing'>Showing { brands && brands.length } brands of { brandsList && brandsList.length }</div>
                    { brandsList && brandsList.length > 5 &&
                        <div className='showall' onClick={showBrands}>{showAllBrands ? "Show Less" : "Show All"}</div>
                    }
                </div>
                {(page == "edit-brand" || page == "overview-brand" || page == "overview-edit-brand") && 
                    <div className='sub-brands-right'>
                        <div><img className='create-sub-brand' src={create} alt='create' onClick={() => handleSubBrand('create')}></img></div> 
                </div>}
                {(showPopup) && 
                    <AddSubBrand page={page} brandId={brandId} showPopup={showPopup} setShowPopup={setShowPopup} trigger={trigger}
                    setTrigger={setTrigger} values={values} setValues={setValues} setOpen={setOpen} setError={setError} type={type}/>
                }
            </div>
            <div className='sub-brands-table'>
                <table>
                    <thead>
                        <tr className='heading-row'>
                            <th className='heading-data first-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div>Brand</div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "300px"}}>
                                <div className='heading-arrows'>
                                    <div>Address</div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div>City</div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div className='heading-arrows'>
                                        <div>State / Province</div>
                                    </div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div className='heading-arrows'>
                                        <div>Zip / Postal Code</div>
                                    </div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div className='heading-arrows'>
                                        <div>Country / Region</div>
                                    </div>
                                </div>
                            </th>
                            <th className='heading-data action-heading' style={{width: "120px"}}>Actions</th>
                        </tr>
                    </thead>
                    {
                    brands.length === 0 ? <p className="no-result">No results found</p> :
                        <tbody>
                            { brands && brands.length > 0 && brands.map((item, index) => {
                                return (
                                    <tr className='details-list-row' key={index}>  
                                        <td className='details-list-data first-data' style={{minWidth: "200px"}}>{item.name}</td>
                                        <td className='details-list-data' style={{minWidth: "300px"}}>{item.address}</td>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.city}</td>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.state}</td>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.zipCode}</td>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.country}</td>
                                        <td className='details-list-data action'>
                                            <img className='edit' src={edit} alt="edit" onClick={() => handleSubBrand('edit', item)}></img>
                                            <img className='trash' src={trash} alt="delete" onClick={(e) => deleteSubBrand(e, item.idBrand)}></img></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    }   
                </table>
            </div>
            <DeleteItem show={showDeletePopup} handleClose={handleCloseDeletePopup} deleteApiCall={deleteSubBrandApi} enable={true}/>
        </div>
    );
}

export default SubBrands;